import { Modal, Box, Typography, Button } from '@mui/material';
import COLORS from '../../../resources/style/Themes';
import { useTranslation } from 'react-i18next';
import { StringKeys } from '../../../resources/strings/StringKeys';

function InfoModal({ show, onHide, infoTitle, infoMessage }) {
  const { t } = useTranslation();

  return (
    <Modal
      open={show}
      onClose={onHide}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          width: { xs: '90%', sm: '80%', md: '60%', lg: '50%' },
          bgcolor: 'background.paper',
          borderRadius: 3,
          boxShadow: 24,
          outline: 'none',
          overflow: 'hidden',
        }}
      >
        {/* Header Section */}
        <Box
          sx={{
            backgroundColor: COLORS.SAFEGUARD_BLUE,
            color: COLORS.WHITE,
            padding: 2,
            borderBottom: `1px solid ${COLORS.WHITE}`,
          }}
        >
          <Typography id="modal-title" variant="h6">
            {infoTitle}
          </Typography>
        </Box>

        {/* Modal Content */}
        <Box sx={{ p: 3 }}>
          <Typography id="modal-description">{infoMessage}</Typography>
        </Box>

        {/* Footer Section */}
        <Box
          sx={{
            p: 2,
            textAlign: 'right',
            borderTop: `1px solid ${COLORS.WHITE}`,
          }}
        >
          <Button variant="contained" color="secondary" onClick={onHide}>
            {t(StringKeys.OK)}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}

export default InfoModal;
